import { render, staticRenderFns } from "./SingleInquiry.vue?vue&type=template&id=98d65f52&scoped=true"
import script from "./SingleInquiry.vue?vue&type=script&lang=ts"
export * from "./SingleInquiry.vue?vue&type=script&lang=ts"
import style0 from "./SingleInquiry.vue?vue&type=style&index=0&id=98d65f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d65f52",
  null
  
)

export default component.exports